import Ada              from './controllers/ada';
import Account          from './controllers/account';
import Accordion        from './controllers/accordion';
import AgeGate          from './controllers/age-gate';
import AjaxLoader       from './controllers/ajax-loader';
import Carousel         from './controllers/carousel';
import Cart             from './controllers/cart';
import Collection       from './controllers/collection';
import EmailPopup       from './controllers/email-popup';
import GdprPopup        from './controllers/gdpr-popup';
import GridItemResizer  from './controllers/grid-item-resizer';
import Header           from './controllers/header';
import HorizontalSlider from './controllers/horizontal-slider';
import ImageLoader      from './controllers/image-loader';
import PageScroller     from './controllers/page-scroller';
import Product          from './controllers/product';
import Reviews          from './controllers/reviews';
import Router           from './controllers/router';
import SamplesPage      from './controllers/samples-page';
import ScrollingMarquee from './controllers/scrolling-marquee';
import ScrollSlideshow  from './controllers/scroll-slideshow';
import SectionSwitcher  from './controllers/section-switcher';
import StickyMenu       from './controllers/sticky-menu';
import UrlUpdater       from './controllers/url-updater';
import VideoPlayer      from './controllers/video-player';

//=============================================================================
// This acts as the root controller for the website.
// Separate your logic into modules.
// Save module instances in the SuperTheme state.
// Rock hard, ride free!
//=============================================================================

class SuperTheme {
  constructor() {
    this.state = {};
    this.state.ada              = new Ada(true);
    this.state.account          = new Account(true);
    this.state.sectionSwitcher  = new SectionSwitcher(true);
    this.state.accordion        = new Accordion(true);
    this.state.ageGate          = new AgeGate(true);
    this.state.ajaxLoader       = new AjaxLoader(true);
    this.state.carousel         = new Carousel(true);
    this.state.cart             = new Cart(true);
    this.state.collection       = new Collection(true);
    this.state.emailPopup       = new EmailPopup(true);
    this.state.gdprPopup        = new GdprPopup(true);
    this.state.gridItemResizer  = new GridItemResizer(true);
    this.state.header           = new Header(true);
    this.state.horizontalSlider = new HorizontalSlider(true);
    this.state.imageLoader      = new ImageLoader(true);
    this.state.pageScroller     = new PageScroller(true);
    this.state.product          = new Product(true);
    this.state.reviews          = new Reviews(true);
    this.state.samplesPage      = new SamplesPage(true);
    this.state.scrollingMarquee = new ScrollingMarquee(true);
    this.state.scrollSlideshow  = new ScrollSlideshow(true);
    this.state.stickyMenu       = new StickyMenu(true);
    this.state.urlUpdater       = new UrlUpdater(true);
    this.state.videoPlayer      = VideoPlayer.init();
    this.state.router           = new Router(true);
  }
}


//=============================================================================
// ¡INIT! Innit?
//=============================================================================

new SuperTheme();
